const path = require('path')

export const templatesDirPath = ln => path.join(global.appRoot,  global.isProd ? `buildServer/server/models/fncs/reportsUtils/templates/${ln}` : `src/server/models/fncs/reportsUtils/templates/${ln}`)

export const imgDirPath = path.join(global.appRoot,  global.isProd ? 'buildServer/img' : 'src/img')
